export default {
  title_filter_items: "Filter Items",
  title_filter_issues: "Filter Issues",
  title_filter_performed_work: "Filter Performed Work",
  title_filter_performed_work_item_class: "Filter Performed Work: Item Class",
  title_filter_work_orders: "Filter Work Orders",
  system_link: "System link (<b class='text-info'>{link_entity}</b>)",
  identifiers: "Identifiers",
  related_entities: "Related entities",
  priorities: "Priorities",
  states: "States",
  entity_grouping: "Entity Grouping",
  conclusion: "Conclusion",
  has_rfid: "Has RFID",
  has_qr_code: "Has QR-Code",
  work_type: "Work Type",
  entity_type: "Entity Type",
  part_of_work_order: "Part of a <b class='text-info'>Work Order</b>",
  raised_through: "Raised through <b class='text-info'>Performed Work</b>",
  included_supersede: "Include <b class='text-info'>Superseded Issues</b>",
  include_rejected: "Include <b class='text-info'>Rejected Issues</b>",
  yes: "Yes",
  no: "No",
  either: "Either",
  item: "Item",
  items: "Items",
  area: "Area",
  corrective: "Corrective",
  regular: "Regular",
  simple: "Simple",
  range: "Range",
  performed: "Performed",
  start_date: "Start Date",
  work_domain: "Work Domain",
  item_class: "Item Class",
  area_attribute_set: "Area Attribute Set",
  priority: "Priority",
  state: "State",
  designation: "Designation",
  raised: "Raised",
  in_work_order: "In Work Order",
  corrected: "Corrected",
  corrected_closed: "Corrected and closed",
  closed: "Closed",
  draft_work_order: "Draft Work Orders",
  planned: "Planned",
  open: "Open",
  in_progress: "In progress",
  behind: "Behind",
  overdue: "Overdue",
  complete: "Complete",
  completed_closed: "Completed and closed",
  unreviewed: "Unreviewed (Open)",
  not_applicable: "Not applicable",
  accepted: "Accepted",
  rejected: "Rejected",
  latest: "Latest",
  none: "None",
  any: "Any",
  days: "Days",
  months: "Months",
  years: "Years",
  issues: "Issues",
  performed_regular_work: "Performed Regular Work",
  performed_regular_work_raised: "Performed Regular Work (Raised from)",
  performed_corrective_work: "Performed Corrective Work",
  work_orders: "Work Orders",
  place_holder_work_domain: "Filter by Work Domain...",
  place_holder_state: "Filter by State...",
  place_holder_designation: "Type to filter by designation...",
  place_holder_item_class: "Filter by Item Class...",
  place_holder_area_attribute_set: "Filter by Area Attribute Set...",
  notify_disable_time: "Range start date must be set first",
}
